import { MemberDto, VerificationResponseDto } from '@careapp-group/ng-sdk-v2-new';
import {
  ContinueWithVerificationUiFlow,
  LoginFlow,
  RecoveryFlow,
  RegistrationFlow,
  Session,
  SettingsFlow,
  VerificationFlow,
} from '@ory/client';

export interface KratosAuth {
  session: Session;
  userId: string;
}

export interface State {
  loading: boolean;
  resetPassword: boolean;
  error?: string;
  auth?: KratosAuth;
  user?: MemberDto;
  roles?: Array<string>;
  ready: boolean;
  accountRecoveryFlow?: RecoveryFlow;
  loginFlow?: LoginFlow;
  settingsFlow?: SettingsFlow;
  registrationFlow?: RegistrationFlow | 'complete';
  verificationFlow?: VerificationFlow | ContinueWithVerificationUiFlow;
  currentVerification?: VerificationResponseDto;
  currentPasswordResetToken?: {
    id: string;
    ttl: number;
    created: Date;
    userId: string;
    // Not sent from server.
    used?: boolean;
  };
  requestingVerification: boolean;
  requestingPasswordResetToken: boolean;
  passwordChangeFlowId?: string;
  passwordChangeFlow?: 'IN_PROGRESS' | 'COMPLETE';
  postLoginRoute?: string;
}

export const initialState: State = {
  loading: false,
  resetPassword: false,
  error: null,
  ready: false,
  requestingVerification: false,
  requestingPasswordResetToken: false,
  passwordChangeFlow: null,
};
